<template>
  <div class="page-break">
    <el-row>
      <el-col :span="24">
        <p style="font-size: 25px;font-weight:600;width: 100%;text-align: center">
          {{ defaultTitle + '领料出库单' }}</p>
      </el-col>
      <el-col :span="13" style="margin-top:5px;">
        <ul>
          <li>领料单ID：{{ this.titleData.ID }}</li>
          <li>领料人：{{ this.titleData.REQUISITIONER }}</li>
        </ul>
      </el-col>
      <el-col :span="11" style="padding-left: 15px;margin-top:5px;">
        <ul>
          <li>领料部门：{{ this.titleData.DEPARTMENT_NAME }}</li>
          <li>领&nbsp;料&nbsp;日&nbsp;期：{{ this.titleData.SEND_DAY }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <div style="display:flex;">
       <div style="width:123%">
      <el-col :span="22" style="position:relative;">
        <table style="width: 100%">
          <tr class="aa">
            <th style="width: 5%">序号</th>
            <th style="width: 40%" v-if="printCode == 1">产品编码</th>
            <th style="width: 10%">产品</th>
            <th style="width: 5%">单位</th>
            <th style="width: 8%">单价</th>
            <th style="width: 10%">领料数量</th>
            <th style="width: 8%">领料金额</th>
            <th style="width: 8%">备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td v-if="printCode == 1">{{ item.PRODUCT_CODE }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td>{{ item.PRICE }}</td>
            <td>{{ item.PRODUCT_COUNT }}</td>
            <td>{{ (item.PRODUCT_COUNT * item.PRICE).toFixed(2) }}</td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
      </div>
      <div style="display:flex;flex-direction: column;font-size:0;height:0">
        <span style="font-size:15px">白</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">财</span>
        <span style="font-size:15px">务</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">红</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">存</span>
        <span style="font-size:15px">根</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">黄</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">领</span>
        <span style="font-size:15px">料</span>
      </div>
      </div>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col style="width:85%;display: flex; justify-content: space-between ;">


        <span>领料总金额：{{ this.TOTAL_FEE }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>制单人：{{ this.领料单创建人 }}</span>
      </el-col>
      <el-col :span="6">
        <span>领料人：</span>
      </el-col>
      <el-col :span="6">
        <span>部门主管：</span>
      </el-col>
      <el-col :span="6">
        <span>发料人：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="20" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    materialRequisitionCreator: {
      type: String,
      default: ''
    },
    manager: String,
    supplier: String,
    title: String,
    totalAmount: Number,
    IsPrintCode: String,
  },
  data() {
    return {
      领料单创建人:'',
      Ishistory: false,
      topData: [],
      mainData: [],
      managername: '',
      TOTAL_FEE: 0,
      imgUrl: '',
      printSupplier: '',
      printName: sessionStorage.getItem('supplierName'),
      sendFlag: sessionStorage.getItem('sendFlag'),
      printTitle: '',
      defaultTitle: sessionStorage.getItem('company'),
      flag: false,
      catalogFlag: sessionStorage.getItem('catalogFlag'),
      tcId: sessionStorage.getItem('tcId'),
      titleData: [],
      printCode: '',
    };
  },
  created() {
    this.titleData = JSON.parse(sessionStorage.getItem('titleData'));
    this.topData = this.headerData;
    this.领料单创建人 = this.materialRequisitionCreator
    this.mainData.push(this.tableData);
    if (this.mainData[0].IsHistoryFalg) {
      this.Ishistory = true;
    } else {
      this.Ishistory = false;
    }
    this.managername = this.manager;
    this.TOTAL_FEE = this.totalAmount.toFixed(2);
    this.printTitle = this.title;
    this.printCode = this.IsPrintCode;
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.titleData.ORDER_ID}.png`;
    // this.imgUrl = 'http://47.99.59.146/file/barcode/'+ this.topData[0].ORDER_ID + '.png'
    if (Number(sessionStorage.getItem('realCountFlag')) !== 0) {
      this.flag = true;
    } else {
      this.flag = false;
    }
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 24px;
  line-height: 24px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 24px;
  line-height: 24px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 24px;
  height: 24px;
  font-family: 黑体;
  color: #000;
  /* white-space:nowrap;overflow:hidden;text-overflow:ellipsis; */
  white-space: nowrap;
  /* 因为设置了block，所以需要设置nowrap来确保不换行
      overflow: hidden; /* 超出隐藏结合width使用截取采用效果*/
  text-overflow: ellipsis;
  /* 本功能的主要功臣，超出部分的剪裁方式 */
  -o-text-overflow: ellipsis;
  /* 特定浏览器前缀 */
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingOutShortPrintTax.vue